import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useExpenseAccountByIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, expenseId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _expenseId = isRef<string>(expenseId) ? expenseId : ref<string>(expenseId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		expenseId: _expenseId,
		...useQuery(() => new q.ExpenseAccountByIdQueryV1(_workspaceId.value, _strategyId.value, _expenseId.value))
	}
	return {
		...result,
		runExpenseAccountByIdQueryV1: result.run,
		modelExpenseAccountByIdQueryV1: result.model,
	}
}

export function useExpenseAccountsByStrategyIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ExpenseAccountsByStrategyIdQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runExpenseAccountsByStrategyIdQueryV1: result.run,
		modelExpenseAccountsByStrategyIdQueryV1: result.model,
	}
}

export function useManageCostsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ManageCostsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runManageCostsPageQueryV1: result.run,
		modelManageCostsPageQueryV1: result.model,
	}
}

